"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCheckboxActiveStyles = exports.GetCheckboxHoverStyles = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = require("styled-components");
const styles_1 = require("./styles");
const GetCheckboxHoverStyles = ({ error, disabled, isSelected, }) => {
    if (!error && !disabled) {
        return (0, styled_components_1.css) `
      ${styles_1.StyledSquareCheckbox} {
        border-color: ${theme_1.primary.dark};
        ${isSelected &&
            (0, styled_components_1.css) `
          background-color: ${theme_1.primary.dark};
        `};
      }
    `;
    }
};
exports.GetCheckboxHoverStyles = GetCheckboxHoverStyles;
const GetCheckboxActiveStyles = ({ isSelected, error, }) => {
    if (isSelected) {
        return (0, styled_components_1.css) `
      ${styles_1.StyledSquareCheckbox} {
        border-color: ${theme_1.primary.light};
        background-color: ${error ? theme_1.system.error : theme_1.primary.light};
        svg {
          visibility: visible;

          polyline[id='Checkmark'] {
            stroke-width: 4;
          }
        }
      }
    `;
    }
};
exports.GetCheckboxActiveStyles = GetCheckboxActiveStyles;
//# sourceMappingURL=utils.js.map